module.exports = __webpack_public_path__ + "static/media/1_Pair-a.07033c6e.svg";